import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import SearchDropDown from '../../core/SearchDropDown';

class SearchCollection extends React.Component {

    computeSearch(value) {
        const search = this.props.ordered ?
            {
                search: [
                    {
                        inList: "http://www.w3.org/2004/02/skos/core#memberList",
                        listOf: this.props.collectionIRI
                    },
                    {
                        predicate: "http://www.w3.org/2004/02/skos/core#prefLabel",
                        value: value,
                        isExactMatch: false
                    }
                ],
                graph: [this.props.graph],
                language: this.props.lang,
                entailment: this.props.skosXL ? ["propertyChain"] : [],
                predicates: ["http://www.w3.org/2004/02/skos/core#prefLabel"]
            }
            :
            {
                search: [
                    {
                        predicate: "http://www.w3.org/2004/02/skos/core#member",
                        value: this.props.collectionIRI,
                        reverse: true
                    },
                    {
                        predicate: "http://www.w3.org/2004/02/skos/core#prefLabel",
                        value: value,
                        isExactMatch: false
                    }
                ],
                graph: [this.props.graph],
                language: this.props.lang,
                entailment: this.props.skosXL ? ["propertyChain"] : [],
                predicates: ["http://www.w3.org/2004/02/skos/core#prefLabel"]
            };

        return search;
    }

    render() {

        const { lang, returnConcept } = this.props;

        return (
            <SearchDropDown
                dataTest="search-collection"
                title="Search collection"
                lang={lang}
                chosen={returnConcept}
                search={(value) => this.computeSearch(value)}
                listSelectionDisplay={(result, lang) => Array.isArray(result.prefLabel[lang]) ?
                    result.prefLabel[lang][0]
                    :
                    result.prefLabel[lang]
                }
                listDisplay={(result, lang) => <div data-test="result-label">
                    <Typography variant="body2">
                        {Array.isArray(result.prefLabel[lang]) ?
                            result.prefLabel[lang].sort().join(" AND ")
                            :
                            result.prefLabel[lang]
                        }
                    </Typography>
                </div>
                }
            />
        );
    }
}

SearchCollection.propTypes = {
    ordered: PropTypes.bool.isRequired,
    graph: PropTypes.string.isRequired,
    returnConcept: PropTypes.func.isRequired,
    skosXL: PropTypes.bool.isRequired,
    project: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired
};

export default SearchCollection;